import { homeownerQuotesService } from '@/services/quotes/homeowner';
import { AttachQuotePayload } from '@/services/quotes/types';
import { ValidationError } from '@/shared/exceptions/validation.error';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export type ValidationFieldErrors = Record<string, string>;

export function useUpdateQuote() {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; data?: any; error?: string; message?: string },
    Error | ValidationError,
    { id: string; payload: Partial<AttachQuotePayload> }
  >({
    mutationKey: ['quotes', 'update'],
    mutationFn: async ({ id, payload }) => {
      const stepCode = payload.step?.trim();
      const enrichedPayload: Partial<AttachQuotePayload> = stepCode
        ? { ...payload, validationEventCode: stepCode }
        : payload;
      const response = await homeownerQuotesService.updateQuote(
        id,
        enrichedPayload
      );
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.id],
      });
    },
    onError: (_error, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
    },
  });
}
